module.exports = __webpack_public_path__ + "img/camp.3772a505.jpg";